import getResponseData from './getResponseData';
import FetchError from './FetchError';

const checkStatus = async <T>(response: Response): Promise<T> => {
  const data = await getResponseData(response);

  if (!response.ok) {
    throw new FetchError(response.status, response.statusText, data);
  }

  return data as T;
};

export default checkStatus;
